import { render, staticRenderFns } from "./DataCredibility.vue?vue&type=template&id=337963fa&scoped=true"
import script from "./DataCredibility.vue?vue&type=script&lang=js"
export * from "./DataCredibility.vue?vue&type=script&lang=js"
import style0 from "./DataCredibility.vue?vue&type=style&index=0&id=337963fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337963fa",
  null
  
)

export default component.exports